import { useEffect } from 'react';
import { useLocation, useRouteError } from 'react-router-dom';
import * as Sentry from '@sentry/react';

// Utils
import { buildLocalizedPath, getLocale } from '@/utils/localeSlug';

const RELOAD_KEY = 'route-error-reload';
const RELOAD_WINDOW_MS = 10_000;

/**
 * Erreur pendant un chargement côté client : le plus souvent, le manifeste SSG ou un chunk JS
 * est introuvable juste après un déploiement. Un rechargement complet récupère le HTML à jour.
 * Si l'erreur se reproduit, on bascule sur la page 404 générée pour la locale.
 */
function RouteError() {
  const error = useRouteError();
  const { pathname } = useLocation();

  useEffect(() => {
    Sentry.captureException(error);

    const notFoundPath = buildLocalizedPath('404', getLocale(pathname));
    if (pathname === notFoundPath) return; // déjà sur la 404 : pas de boucle

    let lastReload = 0;
    try {
      lastReload = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch {
      // sessionStorage indisponible : on tente quand même un rechargement
    }

    if (Date.now() - lastReload > RELOAD_WINDOW_MS) {
      window.location.reload();
    } else {
      window.location.replace(notFoundPath);
    }
  }, [error, pathname]);

  return null;
}

export default RouteError;